import CategoryIcon from '@mui/icons-material/Category';

const LiveCategoryRoutes = {
  id: 'LiveCategory-group',
  title: 'LiveCategory Management',
  type: 'group',
  children: [
    {
      id: 'LiveCategory-list',
      title: 'LiveCategory List',
      type: 'item',
      url: '/livecategory/list',
      icon: CategoryIcon,
      target: false
    }
  ]
};

export default LiveCategoryRoutes;
